<template>
  <v-container>
    <h2>Challenge History</h2>
    <br>
    <v-row>
      <v-col><v-select label="Type" v-model="selectedType" :items="challengeTypes" hint="Challenge Type" solo persistent-hint /></v-col>
      <v-col><v-combobox v-model="selectedUser" :items="users" item-text="username" hint="User" return-object persistent-hint clearable /></v-col>
    </v-row>
    <v-row>
      <ChallengeList v-if="selectedUser" class="pa-0" :challenge-type="selectedType" :selected-user="selectedUser" show-finished />
    </v-row>
  </v-container>
</template>

<script>

import {eSailServerAuth} from "@/plugins/axios";
import ChallengeList from "../ChallengeList";

export default {
  name: "History",
  components: {ChallengeList},
  data: () => ({
    challengeTypes: ['RACE', 'TIME_TRIAL'],
    selectedType: 'RACE',
    users: [],
    selectedUser: null
  }),
  mounted() {
    const allUsers = { id: -1, username: '--- ALL USERS ---' }
    eSailServerAuth.get('users', { headers: { Authorization: `Bearer ` + this.$auth.token() }})
        .then(response => {
          this.users = [ allUsers, ...response.data ]
        })
  }
}

</script>

<style scoped>

</style>